import React, { useMemo } from 'react';
import useSWR from 'swr';
import { Flex, Link, Select, Text } from '@chakra-ui/react';
import { fetchData } from '../../services/fetch';


// EG-40: seletores do catálogo global.
//
// Estes componentes são a peça que fecha o problema do DOR. Enquanto o campo
// for texto livre, "Governança" e "Governança empresarial" continuam nascendo
// como conceitos distintos — e nenhuma deduplicação por nome resolve isso,
// porque as strings são de fato diferentes. O seletor mostra o que já existe
// ANTES de o gestor inventar um nome novo.

export const PillarSelect = ({
 value,
 onChange,
 idioma,
 isRequired = true,
 id = 'id_pillar',
 label = 'Pilar',
}) => {
 const { data: pilares, isLoading } = useSWR('/pillar', fetchData);

 const opcoes = useMemo(
  () =>
   (pilares || []).filter((pilar) =>
    idioma ? pilar.language === idioma : true
   ),
  [pilares, idioma]
 );

 return (
  <Flex flexDir='column' gap='4px'>
   <Select
    id={id}
    aria-label={label}
    bg='white'
    placeholder={isLoading ? 'Carregando pilares...' : 'Selecione o pilar'}
    value={value ?? ''}
    isDisabled={isLoading}
    isRequired={isRequired}
    onChange={(evento) =>
     onChange(evento.target.value ? Number(evento.target.value) : null)
    }
   >
    {opcoes.map((pilar) => (
     <option key={pilar.id_pillar} value={pilar.id_pillar}>
      {/* O idioma no rótulo não é decoração: "Ambiental" existe em pt-BR e
          es com conteúdo diferente. Sem ele o gestor escolhe o errado e o
          respondente vê o card em outra língua. */}
      {`${pilar.name_pillar} (${pilar.language})`}
     </option>
    ))}
   </Select>

   <Text fontSize='xs' color='gray.500'>
    Não encontrou o pilar?{' '}
    <Link href='/pillars' color='blue.500'>
     Cadastrar em Pilares
    </Link>
   </Text>
  </Flex>
 );
};

export const ThemeSelect = ({
 idPillar,
 value,
 onChange,
 isRequired = false,
 id = 'id_theme',
 label = 'Tema',
}) => {
 const { data: temas, isLoading } = useSWR('/theme', fetchData);

 // Tema pertence a um pilar. Oferecer temas de outro pilar produziria uma
 // classificação que o backend recusa — e confunde o gestor sem necessidade.
 const opcoes = useMemo(
  () =>
   idPillar
    ? (temas || []).filter(
       (tema) => String(tema.id_pillar) === String(idPillar)
      )
    : [],
  [temas, idPillar]
 );

 // EG-41: 4 dos 47 pilares vivos não têm nenhum tema. Como o CA03 torna o tema
 // obrigatório assim que há pilar, escolher um desses prendia o gestor num beco
 // sem saída: campo obrigatório, dropdown vazio e nenhuma pista do que fazer.
 const semTemas = Boolean(idPillar) && !isLoading && opcoes.length === 0;

 return (
  <Flex flexDir='column' gap='4px'>
   <Select
    id={id}
    aria-label={label}
    bg='white'
    placeholder={
     semTemas
      ? 'Nenhum tema neste pilar'
      : idPillar
      ? 'Selecione o tema'
      : 'Escolha o pilar primeiro'
    }
    value={value ?? ''}
    isDisabled={!idPillar || isLoading}
    isRequired={isRequired}
    onChange={(evento) =>
     onChange(evento.target.value ? Number(evento.target.value) : null)
    }
   >
    {opcoes.map((tema) => (
     <option key={tema.id_theme} value={tema.id_theme}>
      {tema.title}
     </option>
    ))}
   </Select>

   {semTemas && (
    <Text fontSize='xs' color='orange.600'>
     Este pilar não tem temas cadastrados.{' '}
     <Link href='/themes' color='blue.500'>
      Cadastrar em Temas
     </Link>
    </Text>
   )}
  </Flex>
 );
};
